import api from '../api/apiClient'
import type { LoginRequest, RegisterRequest, VerifyEmailRequest, TelegramLoginRequest, AuthResponse } from '../models/auth'

export const authRepository = {
  login: async (data: LoginRequest): Promise<AuthResponse> => {
    const response = await api.post('/auth/login', data)
    return response.data
  },

  register: async (data: RegisterRequest): Promise<AuthResponse> => {
    const response = await api.post('/auth/register', data)
    return response.data
  },

  verifyEmail: async (data: VerifyEmailRequest) => {
    const response = await api.post('/auth/verify', data)
    return response.data
  },

  telegramLogin: async (data: TelegramLoginRequest): Promise<AuthResponse> => {
    const response = await api.post('/auth/telegram', data)
    return response.data
  },

  logout: async () => {
    const response = await api.post('/auth/logout')
    return response.data
  }
}